import Styles from './FrameSidebar.module.scss'
import { TLShapeId } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { FrameShape } from './Types'
import { Delete } from './Delete'
import { Duplicate } from './Duplicate'
import { AddPage } from './AddPage'
import { getOrderedFrames } from './helpers'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { channelSupportsCaption } from 'components/Design/utils/channelSupportsCaption'
import { DesignChannel } from 'components/NewFileModal/Types'
import { isSinglePageChannel } from 'components/Design/utils/isSinglePageChannel'

interface Props {
  id: TLShapeId
}
export const FrameSidebar = observer(({ id }: Props) => {
  const editor = useEditor()
  const shape = editor.getShape<FrameShape>(id)
  const { designStore } = useRootStore()
  const channel = designStore?.file?.channel

  if (!shape || !designStore?.file) return null

  const { h } = shape.props
  const framesCount = getOrderedFrames(editor).length
  const supportsCaption = channelSupportsCaption(designStore.file?.channel as DesignChannel)

  return (
    <div
      className={Styles.frameSidebar}
      style={{
        height: `calc(var(--tl-zoom) * ${Math.ceil(h)}px)`,
      }}
    >
      {framesCount > 1 && (
        <>
          <Delete id={id} supportsCaption={supportsCaption} />
        </>
      )}
      {!isSinglePageChannel(channel as DesignChannel) && (
        <>
          <Duplicate id={id} supportsCaption={supportsCaption} />
          <AddPage id={id} supportsCaption={supportsCaption} />
        </>
      )}
    </div>
  )
})
